module.exports = __webpack_public_path__ + "img/cn-logo.e1fff77a.png";